module.exports = __webpack_public_path__ + "static/media/logo_dark.692dbc91.svg";